import {IUser} from "../../../../../app/interfaces/user/IUser";
import {IChatSocketCommand} from "../../../../../app/types/ChatSocketCommand";

export const loginToChatCommand = (user: IUser): IChatSocketCommand => ({
    cmd: 'login',
    message: user.uniqueUserValue ?? user.idStr ?? ''
});